import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";
import DetailRow from "../../../../components/UI/viewDialogs/DetailRow";
import { checkValue } from "../../../../functions/checkValue";
import { timeStampToDateAndTime } from "../../../../functions/dateTime/timeStampToDateAndTime";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import { getVisitStatus } from "../../helpers/getComplaintStatus";
import GetCheckCross from "../../../../components/UI/viewDialogs/GetCheckCross";

VisitModalLayout.VisitDetails = function Details() {
  const { visit } = useVisitDialog();
  // Variables to store Junior Engineer (JE) name and phone numbe
  let jeName = "";
  let jePhone = "";

  // Extract JE Name and Phone from the 'siteJe' string
  if (visit.siteJe) {
    [jeName, jePhone] = visit.siteJe.split(",").map((str) => str.trim());
  }

  return (
    <div className="view-dialog-content-wrap">
      <DetailRow title="Visit Description" value={visit.description} />
      <div className={`${getVisitStatus(visit.status).textColor}`}>
        <DetailRow title="Status" value={getVisitStatus(visit.status).status} />
      </div>
      <DetailRow title="Site ID" value={visit.station.id} />
      <DetailRow title="Site Name" value={visit.station?.name} />
      {visit.complaint && (
        <>
          <DetailRow
            title="Complaint ID"
            value={checkValue(visit.complaint?.id)}
          />
          <DetailRow
            title="Complaint Description"
            value={checkValue(visit.complaint?.description)}
          />
        </>
      )}
      <DetailRow title="Visited At" value={formatDate(visit.visitedAt)} />
      <DetailRow
        title="Created At"
        value={timeStampToDateAndTime(visit.createdAt)}
      />
      <DetailRow title="Created By" value={visit.createdBy.fullName} />
      <DetailRow
        title="Updated At"
        value={timeStampToDateAndTime(visit.updatedAt)}
      />
      <DetailRow title="Updated By" value={visit.updatedBy.fullName} />
      {visit.checkedAt && (
        <DetailRow
          title="Checked At"
          value={timeStampToDateAndTime(visit.checkedAt)}
        />
      )}
      {visit.checkedBy && (
        <DetailRow title="Checked By" value={visit.checkedBy.fullName} />
      )}
      <DetailRow
        title="Field Technician"
        value={visit.fieldTechnician.fullName}
      />
      {jeName && <DetailRow title="JE Name" value={jeName} />}
      {jePhone && <DetailRow title="JE Phone" value={jePhone} />}
      <DetailRow title="Category" value={visit.category.name} />
      <DetailRow title="Work Done" value={visit.workDone} />
      <DetailRow
        title="Supply Hours/Day"
        value={visit.supplyHours ? visit.supplyHours / 100 : "-"}
      />
      <DetailRow
        title="Working Cylinder"
        value={checkValue(visit.workingCylinderID)}
      />
      <DetailRow
        title="Standby Cylinder"
        value={checkValue(visit.standbyCylinderID)}
      />
      <DetailRow
        title="Last Visit Working Cylinder"
        value={checkValue(visit.lastWorkingCylinderID)}
      />
      <DetailRow
        title="Last Visit Standby Cylinder"
        value={checkValue(visit.lastStandbyCylinderID)}
      />
      <DetailRow
        title="Ejector vacuum working"
        value={<GetCheckCross checkVal={visit.ejectorVacuumCheck} />}
      />
      <DetailRow
        title="Ejector back pressure check"
        value={<GetCheckCross checkVal={visit.ejectorBackPressureCheck} />}
      />
      <DetailRow
        title="Hooter working"
        value={<GetCheckCross checkVal={visit.hooterCheck} />}
      />
      <DetailRow
        title="Leak detector"
        value={<GetCheckCross checkVal={visit.leakDetectorCheck} />}
      />
      <DetailRow
        title="Sample valid"
        value={<GetCheckCross checkVal={visit.sampleCheck} />}
      />
      <DetailRow
        title="Ammonia Leakage check"
        value={<GetCheckCross checkVal={visit.ammoniaLeakageCheck} />}
      />
      <DetailRow
        title="Scrubber Working"
        value={<GetCheckCross checkVal={visit.scrubberWorking} />}
      />
      <DetailRow
        title="Cylinder Change"
        value={<GetCheckCross checkVal={visit.cylinderChange} />}
      />
      <DetailRow
        title="Operator Phone No."
        value={checkValue(visit.operatorPhoneNumber)}
      />
      <DetailRow title="Tube Size" value={`${checkValue(visit.tubeSize)}mm`} />
      <DetailRow title="Dose set" value={checkValue(visit.doseSet)} />
      <DetailRow title="Office Remark" value={checkValue(visit.officeRemark)} />
      <DetailRow title="Check Remark" value={checkValue(visit.checkRemark)} />
    </div>
  );
};
